module.exports = __webpack_public_path__ + "img/unicorn.93f49de5.png";